import React, { useState } from "react";

export const toNullIfEmpty = (value) => {
    if (value === undefined || value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    return value;
};

export const toNumberOrNull = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const num = Number(value);
    return isNaN(num) ? null : num;
};

export const toFloatOrNull = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const num = parseFloat(value);
    return isNaN(num) ? null : num;
};

/** Formats "HH:MM" to "HH:MM:SS". */
export const formatTimeSpan = (timeValue) => {
    if (!timeValue) return null;
    const [hours, minutes] = timeValue.split(':');
    return `${hours}:${minutes}:00`;
};

export const toBooleanOrNull = (value) => {
    if (value === undefined || value === null) return null;
    if (typeof value === 'boolean') return value;

    if (typeof value === 'number') {
        if (value === 1) return true;
        if (value === 0) return false;
    }

    if (typeof value === 'string') {
        const lower = value.toLowerCase();
        if (lower === 'true' || lower === '1') return true;
        if (lower === 'false' || lower === '0') return false;
    }

    return null;
};

/** Formats an ISO date string to DD/MM/YY by splitting the date part directly. */
export const formatShortDate = (isoDate) => {
    if (!isoDate) return isoDate;
    const [year, month, day] = isoDate.split('T')[0].split('-');
    return `${day}/${month}/${year.substring(2)}`;
};

export const CustomTooltip = ({ children, content }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div
            onMouseOver={() => setShowTooltip(true)}
            onMouseOut={() => setShowTooltip(false)}
            style={{ position: 'relative', display: 'inline-block' }}
        >
            {children}
            {showTooltip && (
                <div className="custom-tooltip show">
                    {content}
                </div>
            )}
        </div>
    );
};

/** Formats a date string to a full date-time with milliseconds (en-GB). */
export const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    const formattedDate = date.toLocaleString("en-GB", {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
    });
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
    return `${formattedDate}.${milliseconds}`;
};

/** Formats a Date to DD/MM/YY using the Date object (handles non-ISO inputs). */
export const formatDate = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return '';

    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear().toString().slice(-2);

    return `${day}/${month}/${year}`;
};

/** Formats a Date to HH:MM. */
export const formatTime = (time) => {
    if (!time) return '';

    if (typeof time === 'string' && /^\d{1,2}:\d{2}$/.test(time)) {
        return time;
    }

    const dateObj = new Date(time);
    if (isNaN(dateObj.getTime())) return '';

    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
};

/** Formats a number as GBP currency (£##,##0.00). */
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '';

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) return '';

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numAmount);
};
